import { createPinia } from "pinia";
import { getUrlParams, getGameId } from "@/utils";
enum PlatformEnum {
  GLOBAL = "global",
  GM99 = "gm99",
  JP = "jp",
}
const pinia = createPinia();
export const PLATFORM = PlatformEnum.GLOBAL;
export const GAME_ID = getGameId();
export default pinia;

// 导出所有store
export * from "./user";
export * from "./forum";
export * from "./thread";
export * from "./toast";
export * from "./search";
export * from "./like";
export * from "./favorite";
export * from "./bind";
export * from "./share";
export * from "./confirm";
export * from "./imageViewer";
export * from "./video";
export * from "./otherUser";
export * from "./pageTime";
export * from "./language";
export * from "./page";
export * from "./point";